module.exports = __webpack_public_path__ + "static/6-6f8f3fd03fb9c2d5466925e8b136f1c6.png";